// extracted by mini-css-extract-plugin
export default {"shadow":"ModalWindowBase_shadow__QKhJm"};